<template>
  <div class="iv-imp-cultural">
    <div class="iv-si-think">
      <p class="iv-heart-letter"><span class="span1">文化大事纪</span><span class="span2" @click="goToList">...</span> </p>
      <div class="iv-si-con">
        <ul>
          <template v-for="(item) in movieList" >
            <li class="iv-list-li" :key='item.title' @click="todetail(item)">
              <div class="left1">
                <p class="time">{{getTime(item.publishDate)}}</p>
                <p class="title">{{item.title}}</p>
                <p class="content">{{item.summary}}</p>
              </div>
              <div class="right1">
                <img :src="getImgPath(item.coverPicId)" @error="nofind"/>
                <img class="iv-zd" src="@/assets/images/zhiding.png" v-if="item.orderNum"/>
              </div>
            </li>
          </template>
      </ul>
      </div>
    </div>
  </div>
</template>

<script>
// import news from '../../../../../index/components/news-center/news.js'
// import info from './info.js'
import {newsPrefixPath} from '@/config'
import { timeFormat } from '@/utils'
import Iconfont from '@/components/iconfont' 

export default {
  data () {
    return {
      movieList: [],
      zdUrl: '@/assets/images/zhiding.png',
      navMap: {}
    }
  },
  props: ['navData'],
  created () {
    // this.initTabs()
    this.getmanagerThought()
  },
  watch: {
    navData (val) {
      this.navMap = val
    }
  },
  methods: {
    getmanagerThought () {
      this.$ajax({
        url: 'api-qixuan/infoPublish/info/public/byCode/list',
        method: 'get',
        data: {
          code: 'manager_idea',
          rowNum: '1'
        }
      }).then(({data}) => {
        this.movieList = data.data['manager_idea']
      })
    },
    getImgPath (id) {
      return id ? `${newsPrefixPath}file/downloadFile?fileId=${id}` : require('@/assets/images/news/default-pic.png')
    },
    getTime (d) {
      return timeFormat(d)
    },
    todetail (item) {
      const { href } = this.$router.resolve({
        name: 'newsDetail',
        query: {
          infoId: item.id,
          categoryName:item.columnName
        }
      })
      window.open(href, '_blank')
    },
    goToList () {
      const { href } = this.$router.resolve({
        name: 'manager_idea',
        query: {
          categoryCode: 'manager_idea',
          categoryName: '管理者思想',
          categoryId: this.navMap['manager_idea'].categoryId,
          categoryType: this.navMap['manager_idea'].categoryType
        }
      })
      window.open(href, '_blank')
    },
    nofind () {
      var img = event.srcElement
      img.src = require('@/assets/images/news/default-pic.png')
      img.onerror = null
    }
  },
  components: {
    Iconfont
  }
}
</script>

<style lang="scss" scoped>
.iv-list-li {
  cursor: pointer;
}
.iv-imp-cultural {
    margin-top: 40px;
    .iv-si-think {
      width: 1200px;
      // height: 71px;
      font-size: 32px;
      display: inline-block;
      // font-family: SourceHanSerifCN-Bold, SourceHanSerifCN;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
      line-height: 38px;
      background-color: #fff;
    }
    .iv-heart-letter {
      border-top: 1px solid rgba(0, 0, 0, 0.15);
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      height: 71px;
      line-height: 71px;
      width: 1200px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 30px;
      .span1 {
        float: left;
        border-top: 2px solid #FFC757;
        height: 30px;
        font-family:'PingFang SC';
      }
      .span2 {
        float: right;
        color: rgba(0, 0, 0, 0.45);
        cursor: pointer;
        line-height: 60px;
      }
    }
    .iv-si-con {
      ul {
        li {
          margin-top: 39px;
          height: 280px;
          .right1 {
            float: right;
            // width: 250px;
            // height: 140.625px;
            position: relative;
            .iv-zd {
              position: absolute;
              left: 0;
              top: 0;    
              width: 40px;
              height: 40px;
            }
            img {
              width: 280px;
              height: 280px;
              border-radius: 50%;
              object-fit: cover;
              border: 2px solid #009AD8;
            }
          }
          .left1 {
            width: 880px;
            float: left;
            .title {
              font-size: 24px;
              font-weight: 600;
              color: rgba(0, 0, 0, .88);
              line-height: 24px;
              font-family:'PingFang SC';
              margin-top: 10px;
            }
            .content {
              font-size: 16px;
              font-family:'PingFang SC';
              color: rgba(0, 0, 0, .64);
              line-height: 24px;
              margin-top: 18px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
            }
            .time {
              font-size: 20px;
              font-family:'PingFang SC';
              color: #2373C8;
              margin-top: 50px;
            }
          }
        }
      }
    }
  }
</style>